import { Component, OnInit, ViewChild } from '@angular/core';
import { DatatableComponent } from '../datatable/datatable.component';

@Component({
  selector: 'app-homepage',
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss']
})
export class HomepageComponent implements OnInit {
  @ViewChild('child') child: DatatableComponent;

  constructor() { }

  ngOnInit(): void {}

  getTableRecords(data: any) {
    this.child.searchedRecords(data);
  }

  showDataTable(val: any) {
    this.child.showDataTable(val);
  }

  getSearchFormValues(data: any) {
    this.child.searchedFormValues(data);
  }

}
